import { logEvent } from "firebase/analytics";
import { addDoc, collection, doc, onSnapshot, query, setDoc, Timestamp, where } from "firebase/firestore";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FirebaseContext } from "./context";
import { Photo } from "./Photo";

interface EventProps {
    image?: string;
    title?: string;
    description?: string;
    start?: string;
    end?: string;
    id: string;
    outdated?: boolean;
}

export const Event = ({
    id,
    ...props
}: EventProps) => {
    const { db, analytics } = useContext(FirebaseContext);
    const navigate = useNavigate();
    const [ participants, setParticipants ] = useState<string[]>([]);
    useEffect(() => {
        if (db) {
            return onSnapshot(query(collection(db, 'v2-events', id, 'ps'), where("public", '==', true)), (snapshot) => setParticipants(snapshot.docs.map((l) => l.id)));
        }
    }, [db, id]);
    return <div className="flex justify-between cursor-pointer transition-all hover:translate-x-5 flex-wrap" onClick={() => {
        logEvent(analytics!, 'check', {
            content_type: 'event',
            content_id: id
        });
        navigate(`/event/${id}`);
    }}>
        <div className='flex gap-5'>
            <div className="bg-[#01487C] sio w-1 h-full min-w-[0.25rem]"></div>
            { props.image ? <div className="hio"><Photo src={props.image} size={'small'}/></div> : null}
            <div>
                <div className="flex flex-wrap align-baseline gap-x-3 gap-y-1">
                    <p className='text-2xl'>{props.title}</p>
                    {props.outdated ? <div className="align-middle leading-7 flex flex-col justify-center"><div className="bg-[#01487C] text-white rounded-full px-3 py-1 text-sm w-fit h-fit">Прошедшее</div></div> : null}
                </div>
                <p className='text-lg'>{props.description}</p>
                <p className='text-gray-500'>{props.start} - {props.end}</p>
            </div>
        </div>
        <div className="flex flex-col justify-center float-right hio">
            <div className="flex gap-5">
                <p className="text-gray-500 text-lg">{participants.length}</p>
                <i className="fa-solid fa-users text-[#01487C] fa-2x"></i>
            </div>
        </div>
    </div>
}